import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class HttpQueuedInterceptor implements HttpInterceptor {
  private isProcessing = false;
  private requestQueue: Array<{
    request: HttpRequest<any>;
    resolve: Function;
    reject: Function;
  }> = [];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.keys().includes('x-front-queue-tested')) {
      return new Observable((observer) => {
        this.requestQueue.push({
          request: req,
          resolve: (data) => {
            observer.next(data);
            observer.complete();
          },
          reject: observer.error.bind(observer)
        });

        if (!this.isProcessing) {
          this.processQueue(next);
        }
      });
    }

    return next.handle(req);
  }

  private processQueue(next: HttpHandler) {
    if (this.isProcessing || !this.requestQueue.length) {
      return;
    }

    this.isProcessing = true;

    const { request, resolve, reject } = this.requestQueue.shift();

    next
      .handle(request)
      .pipe(
        switchMap((event) => {
          if (event instanceof HttpResponse) {
            resolve(event);
          }

          return of(event);
        }),
        catchError((error) => {
          reject(error);
          return of(error);
        })
      )
      .subscribe({
        complete: () => {
          this.isProcessing = false;
          this.processQueue(next);
        }
      });
  }
}
